const getRateList = (state, payload) => {
  state.rateList = payload.data;
}



export default {
  getRateList,
}


// WEBPACK FOOTER //
// ./src/store/modules/rateManagement/mutations.js